module.exports = __webpack_public_path__ + "media/courses/curricula/images/level-empty-a7110aa489b1d8c5868c9751517469ae.svg";